import React, { createContext, useContext } from "react";

export const LocaleContext = createContext();

const LocaleProvider = ({ locale, children }) => (
  <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
);

export const useLocale = () => useContext(LocaleContext);

export default LocaleProvider;
